export function getContributorsList() {
  throw new Error('getContributorsList called on the client!');
}
